import { Controller } from "@hotwired/stimulus";

// Live price recalculation as ancillary checkboxes (baggage/CFAR/climate)
// are toggled on an itinerary card -- mirrors what the old Vue
// itinerary_air_base.vue mixin's priceChange() did (sum every checked
// box's data-price/data-price-pax onto the base price), ported to
// Stimulus since that whole Vue tree was retired this session. Same
// simplified sv-SE/"kr" formatting limitation as offer_selector_controller.js:
// correct on the initial server render, an approximation while toggling.
export default class extends Controller {
  static targets = ["checkbox", "total", "perPerson"];
  static values = { basePrice: Number, basePricePax: Number };

  recalculate() {
    let extra = 0;
    let extraPax = 0;

    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.checked) return;
      extra += Number(checkbox.dataset.price || 0);
      extraPax += Number(checkbox.dataset.pricePax || 0);
    });

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = this.formatCurrency(this.basePriceValue + extra);
    }
    if (this.hasPerPersonTarget) {
      this.perPersonTarget.textContent = this.formatCurrency(this.basePricePaxValue + extraPax);
    }
  }

  formatCurrency(amount) {
    return Math.round(amount).toLocaleString("sv-SE") + " kr";
  }
}
